// подробное описание этих статусов есть в задаче NC-4474
export enum ELECTRONIC_CONSENT_STATUS {
	NEW = 'new',
	SENT = 'sent',
	ACTIVATED = 'activated',
	COMPLETED = 'completed',
	DELETED = 'deleted',
	ARCHIVE = 'archive',
	NOT_ACTUAL = 'not_actual',
	COMPLETED_NOT_ACTUAL = 'completed_not_actual',
	WITH_VIOLATION = 'with_violation',
}

export enum ORDERS_STATUS {
	HAS_ORDER = 'has_order',
	HAS_NO_ORDER = 'has_no_order',
	RESERV_AVAILABLE = 'fill_reserve_available',
	ORDER_AVAILABLE = 'fill_order_available',
}

export enum AGREEMENT_STATE {
	ACTUAL = 'actual',
	ARCHIVE = 'archive',
}

export enum AGREEMENT_SUBTYPES {
	MAIN = 'main',
	RULE = 'rule',
	CONSENT = 'consent',
}

export enum AGREEMENT_PARENT_TYPES {
	SBER_MQ__ORDER = 'sber_mq__order',
	USER = 'User',
	AD = 'Ad',
}

export enum AGREEMENT_TYPE {
	SMS = 'sms',
	PAPER = 'paper',
}

export const ALREADY_EXISTS = 'already_exists'
